import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Notification {
  id: string
  title: string
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
  action?: {
    label: string
    onClick: () => void
  }
}

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notification[]>([])

  const notificationStore = useNotificationStore()

  const addNotification = (notification: Omit<Notification, 'id'>) => {
    const id = Date.now().toString()
    notificationStore.notifications.push({
      id,
      ...notification
    })

    // Auto remove after 5 seconds if no action
    if (!notification.action) {
      setTimeout(() => {
        notificationStore.removeNotification(id)
      }, 5000)
    }
  }

  const removeNotification = (id: string) => {
    notifications.value = notifications.value.filter(n => n.id !== id)
  }

  return {
    notifications,
    addNotification,
    removeNotification
  }
})